import React from 'react';

import Profile from '@schools/app/pages/profile/profile';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {}

const ProfilePreview: React.FC<Props> = (props) => {
  return (
    <>
      <div className="u-padding-A-xs" style={{ backgroundColor: colors.purpleLight, color: colors.purple }}>
        <div className="container align-items-center d-flex" style={{ gap: 20 }}>
          <div>
            <strong>Preview Mode</strong>
          </div>

          <div>
            <small>Note: Stat rankings (#x of y) may not display correctly in preview mode!</small>
          </div>
        </div>
      </div>

      <Profile preview />
    </>
  )
};

export default ProfilePreview;
